import { Box, Text } from '@auth0/quantum-product';
import * as React from 'react';
import { LetterSection } from '../LetterSection';
export var Terms = function (_a) {
    var _b = _a.letters, letters = _b === void 0 ? [] : _b, termsByLetter = _a.termsByLetter;
    return (React.createElement(Box, { component: "section" }, letters.length === 0 ? (React.createElement(Text, { variant: "h5", align: "center" }, "No results")) : (letters.map(function (letter) { return React.createElement(LetterSection, { key: letter, letter: letter, terms: termsByLetter[letter] }); }))));
};
